/**
 * AuthContext — 認証状態のグローバル管理
 * ログイン状態・ユーザー情報・種別を提供する。
 */

import { createContext, useState, useEffect, type ReactNode } from 'react'
import type { UserMe } from '../api/types'
import { getMe } from '../api'

interface AuthContextValue {
  user: UserMe | null
  setUser: (u: UserMe | null) => void
  loading: boolean
  certType: 'first_class' | 'second_class' | null
}

export const AuthContext = createContext<AuthContextValue>({
  user: null,
  setUser: () => undefined,
  loading: true,
  certType: null,
})

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<UserMe | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    getMe()
      .then((me) => {
        if (mounted) setUser(me)
      })
      .catch(() => {
        if (mounted) setUser(null)
      })
      .finally(() => {
        if (mounted) setLoading(false)
      })
    return () => {
      mounted = false
    }
  }, [])

  const certType =
    user?.current_cert_type === 'first_class' || user?.current_cert_type === 'second_class'
      ? user.current_cert_type
      : null

  return (
    <AuthContext.Provider value={{ user, setUser, loading, certType }}>
      {children}
    </AuthContext.Provider>
  )
}
